import { oidcService, tokenService } from '@bedrock/fido-sdk';

export const renewToken = () => tokenService.renewOidcToken();

export const refreshToken = () => oidcService.renewAccessToken();
